import { render, staticRenderFns } from "./annualReview.vue?vue&type=template&id=73c56520&scoped=true&"
import script from "./annualReview.vue?vue&type=script&lang=js&"
export * from "./annualReview.vue?vue&type=script&lang=js&"
import style0 from "./annualReview.vue?vue&type=style&index=0&id=73c56520&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c56520",
  null
  
)

export default component.exports